import { Injectable } from '@angular/core';
// import { AuthJwtService } from './auth-jwt.service';
import { HttpClient } from '@angular/common/http';
import {JwtHelperService} from '@auth0/angular-jwt'; // token decoder module

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private http: HttpClient,) {
  }
  jwtHelper: JwtHelperService = new JwtHelperService(); // create jwt helper library
setItem(keyName: string, keyValue: any) {
  if (typeof keyValue === 'object') {
    keyValue = JSON.stringify(keyValue);
  }
  localStorage.setItem(keyName, keyValue);
}

 getItem(keyName: string): any {
  const keyValue = localStorage.getItem(keyName);
  try {
    return JSON.parse(keyValue || '');
  } catch {
    return keyValue;
  }
}

  removeItem(keyName: string) {
    localStorage.removeItem(keyName);
  }

  removeAll() {
    localStorage.clear();
  }
}
